export default "__VITE_ASSET__D$iVuBpF__"